import {
  Box,
  Grid,
  Button,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import { useEffect, useState } from "react";
import {
  getdrpRoomTypeMst,
  getFloorMstdrp,
  getMstWingdrp,
  getPropDropDown,
  getRoomMst,
} from "../../../Api/RoomMst/Api";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { toast } from "react-toastify";
import { getFormMode } from "../../../lib/helpers";
import { useLocation } from "react-router-dom";
import RoomMasterFormOneButton from "./RoomMasterFormOneButton";
import RoomMasterFormOneButtonTwo from "./RoomMasterFormOneButtonTwo.js";
import { getMstPropRoomConfigDashBoard } from "../../../Api/PropertyMst/Api.js";
import { getRoomMasterdropdata } from '../../../Api/PropertyMst/Api'

import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";
import axiosInstance from "../../../lib/axios.js";
import CustomAutoCompleteNew from "../../AutoComplete/CustomAutoCompleteNew.js";
const Form_Mode = getFormMode();


export default function RoomMasterFormOne({ formMode, form, setForm, onImageUpload }) {
  const userId = sessionStorage.getItem('UserId');
  const location = useLocation();
  const isFormDisabled = formMode === Form_Mode.read;
  const [isLoading, setIsLoading] = useState(true);
  const [properties, setProperties] = useState([]);
  const [wings, setWings] = useState([]);
  const [floors, setFloors] = useState([]);
  const [roomType, setRoomType] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isRefreshingWing, setIsRefreshingWing] = useState(false);
  const [isRefreshingFloor, setIsRefreshingFloor] = useState(false);
  const [isRefRoomType, setIsRefRoomType] = useState(false);
  const [mode, setMode] = useState(() =>
    location?.state?.RoomId ? Form_Mode.read : Form_Mode.add
  );


  const spinAnimation = {
    animation: isRefreshingFloor ? 'spin 1s linear infinite' : 'none',
  };
  const spinAnimation2 = {
    animation: isRefreshingWing ? 'spin 1s linear infinite' : 'none',
  };
  const spinAnimation3 = {
    animation: isRefRoomType ? 'spin 1s linear infinite' : 'none',
  };

  const openFloorTab = () => {
    window.open("/floor");
  };
  const openRoomTypeTab = () => {
    window.open("/roomType");
  };

  const openWingTab = () => {
    window.open("/wing");
  };

  const handleRefreshRoomTyp = async () => {
    setIsRefRoomType(true);
    try {
      const response = await axiosInstance.post(`RoomBedTypeMst/getdrpBedTypeMst`);
      const { data: { Status, Data } } = response;
      if (Status === 0 && Array.isArray(Data)) {
        setRoomType(Data);
      } else {
        setRoomType([]);
      }
    } catch (error) {
      console.error("Error refreshing job titles:", error)
    } finally {
      setTimeout(() => {
        setIsRefRoomType(false);
      }, 300);
    }
  };

  const handleRefreshWings = async () => {
    setIsRefreshingWing(true);
    try {
      const response = await axiosInstance.post(`WingMst/getMstWingdrp`, {
        Flag: "F",
        Strwhere: form.property,
      });
      const { data: { Status, Data } } = response;
      if (Status === 0 && Array.isArray(Data)) {
        setWings(Data);
      } else {
        setWings([]);
      }
    } catch (error) {
      console.error("Error refreshing job titles:", error)
    } finally {
      setTimeout(() => {
        setIsRefreshingWing(false);
      }, 300);
    }
  };
  const handleRefreshFloors = async () => {
    setIsRefreshingFloor(true);
    try {
      const response = await axiosInstance.post(`FloorMst/getFloorMstdrp`,
        {
          Flag: "F",
          Strwhere: form.property,
        });

      const { data: { Status, Data } } = response;
      if (Status === 0 && Array.isArray(Data)) {
        setFloors(Data);
      } else {
        setFloors([]);
      }
    } catch (error) {
      console.error("Error refreshing job titles:", error)
    } finally {
      setTimeout(() => {
        setIsRefreshingFloor(false);
      }, 300);
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setForm((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (form.imageFiles) {
      const correctedUrl = form.imageFiles.replace("http:/", "http://");
      setSelectedImage(correctedUrl);
    }
  }, [form.imageFiles]);

  // Handle file input change
  // const handleImageChange = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     setSelectedImage(URL.createObjectURL(file));
  //     console.log("Image URL set:", URL.createObjectURL(file));
  //     if (onImageUpload) {
  //       onImageUpload(file);
  //     }
  //   }
  // };

  // Function to handle file input change
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result;
        setSelectedImage(base64String); // Base64 string
        console.log("Image Base64:", base64String);

        // Example: Fixing image URL if needed
        const correctedUrl = replaceImgPath(base64String);
        console.log("Corrected URL:", correctedUrl);

        if (onImageUpload) {
          onImageUpload(file); // Pass the original file if needed
        }
      };
      reader.readAsDataURL(file); // Convert file to Base64
    }
  };

  // Function to replace incorrect URL path
  function replaceImgPath(url) {
    if (typeof url === 'string') {
      return url.replace('http:/', 'http://');
    }
    return url;
  }

  // useEffect(() => {
  //   const fetchPropertyData = async () => {
  //     setIsLoading(true);
  //     try {
  //       const response = await getRoomMasterdropdata({
  //         Flag: '',
  //         UserId: userId,
  //       });

  //       if (response instanceof Error) {
  //         toast.error(response.message);
  //         return;
  //       }

  //       const { data } = response;

  //       if (data && data.Status === 0 && Array.isArray(data.Data)) {
  //         const formattedProperties = data.Data.map(item => ({
  //           Id: item.PropId,
  //           Name: item.Name
  //         }));

  //         setProperties(formattedProperties);

  //         // If in edit mode and we have a property value, ensure it's selected
  //         if (formMode === Form_Mode.edit && form.property) {
  //           const selectedProperty = formattedProperties.find(p => p.Id === form.property);
  //           if (selectedProperty) {
  //             setForm(prev => ({
  //               ...prev,
  //               property: selectedProperty.Id
  //             }));
  //           }
  //         }
  //       } else {
  //         console.error('Invalid property data format:', data);
  //         toast.error('Error loading property data');
  //       }
  //     } catch (error) {
  //       console.error('Error fetching property data:', error);
  //       toast.error('Failed to load property data');
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  //   fetchPropertyData();
  // }, [formMode]);

  useEffect(() => {
    const fetchPropertyData = async () => {
      setIsLoading(true);
      try {
        const response = await getRoomMasterdropdata({
          Flag: '',
          UserId: userId,
        });

        if (response instanceof Error) {
          toast.error(response.message);
          return;
        }

        const { data } = response;

        if (data && data.Status === 0 && Array.isArray(data.Data)) {
          const formattedProperties = data.Data.map(item => ({
            Id: item.PropId,
            Name: item.Name
          }));

          setProperties(formattedProperties);

          // Automatically select the first property in "add" mode if no property is selected
          if (formMode === Form_Mode.add && !form.property && formattedProperties.length > 0) {
            setForm(prev => ({
              ...prev,
              property: formattedProperties[0].Id
            }));
          }

          // If in edit mode and we have a property value, ensure it's selected
          if (formMode === Form_Mode.edit && form.property) {
            const selectedProperty = formattedProperties.find(p => p.Id === form.property);
            if (selectedProperty) {
              setForm(prev => ({
                ...prev,
                property: selectedProperty.Id
              }));
            }
          }
        } else {
          console.error('Invalid property data format:', data);
          toast.error('Error loading property data');
        }
      } catch (error) {
        console.error('Error fetching property data:', error);
        toast.error('Failed to load property data');
      } finally {
        setIsLoading(false);
      }
    };

    fetchPropertyData();
  }, [formMode, form.property, setForm, userId]);

  useEffect(() => {
    const fetchRoomTypeData = async () => {
      try {
        const response = await getdrpRoomTypeMst();

        if (response?.data?.Status === 0 && response?.data?.responseStatusCode === 1) {
          setRoomType(response.data.Data);
        } else {
          toast.error("Error loading room types");
        }
      } catch (error) {
        console.error('Error fetching room type data:', error);
        toast.error("Failed to load room types");
      }
    };

    fetchRoomTypeData();
  }, []);

  // FLOORS AND WINGS
  useEffect(() => {
    if (form.property) {
      (async () => {
        const [response, wingResponse] = await Promise.all([
          getFloorMstdrp(form.property),
          getMstWingdrp(form.property),
        ]);

        if (response instanceof Error) {
          console.error("Error: Floors could not be fetched");
        } else {
          const {
            data: { Status, responseStatusCode, Data },
          } = response;
          if (Status === 0 && responseStatusCode === 1 && Array.isArray(Data)) {
            setFloors(Data);
          } else {
            return toast.error("Error: Properties not found");
          }
        }
        if (wingResponse instanceof Error) {
          toast.error("Error: Wings could not be fetched");
        } else {
          const {
            data: { Status, responseStatusCode, Data },
          } = wingResponse;
          if (Status === 0 && responseStatusCode === 1 && Array.isArray(Data)) {
            setWings(Data);
          } else {
            return toast.error("Error: Wings not found");
          }
        }
      })();
    }
  }, [form.property]);

  return (
    <Grid container spacing={2}>
      <ToastContainer />
      <Grid container spacing={2}>
        <Grid item lg={8} md={8} xs={12}>
          <Box display="flex" flexDirection="column" gap={2}>
            <Grid item lg={12} md={12} xs={12}>
              {/* <Grid container spacing={3}> */}
              <Box display="flex" flexDirection="column" gap={2}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6} className="form_field">
                    <FormControl
                      variant="filled"
                      fullWidth
                      className="custom-select"
                    >
                      <InputLabel id="property-select-label">
                        Property <span style={{ color: "red" }}>*</span>
                      </InputLabel>
                      <Select
                        labelId="property-select-label"
                        id="property-select"
                        name="property"
                        value={form.property}
                        disabled={isFormDisabled || formMode === Form_Mode.edit}
                        onChange={handleInputChange}
                        className="custom-textfield"
                      >
                        {/* <MenuItem key={""} value={""}></MenuItem> */}
                        {properties.map((property) => (
                          <MenuItem key={property.Id} value={property.Id}>
                            {property.Name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6} className="form_field">
                    <FormControl
                      variant="filled"
                      fullWidth
                      className="custom-select"
                    >
                      <InputLabel id="wing-select-label">
                        Wing<span style={{ color: "red" }}>*</span>
                      </InputLabel>
                      <Select
                        labelId="wing-select-label"
                        id="wing-select"
                        name="wing"
                        value={form.wing}
                        disabled={isFormDisabled || formMode === Form_Mode.edit}
                        onChange={handleInputChange}
                        className="custom-textfield"
                        sx={{
                          borderRadius: 1,
                          paddingRight: '30px',
                        }}
                        endAdornment={
                          (!isFormDisabled || formMode === Form_Mode.edit || formMode === Form_Mode.add) && (
                            <InputAdornment position="end">
                              <AddIcon
                                onClick={openWingTab} 
                                style={{ cursor: "pointer", fontSize: '18px', color: '#2196f3' }}
                              />
                              <RefreshIcon
                                onClick={handleRefreshWings} 
                                sx={{

                                  transition: 'transform 0.3s ease',
                                  cursor: 'pointer',
                                  fontSize: '18px',
                                  color: '#4caf50',
                                }}
                                style={spinAnimation2}
                              />
                              <style>
                                {`
                                @keyframes spin {
                                  from {
                                    transform: rotate(0deg);
                                  }
                                  to {
                                    transform: rotate(360deg);
                                  }
                                }
                              `}
                              </style>
                            </InputAdornment>
                          )
                        }
                      >
                        {wings.map((wing) => {
                          return (
                            <MenuItem key={wing.Id} value={wing.Id}>
                              {wing.Name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    {/* <CustomAutoCompleteNew
                      options={wings}
                      value={wings.find((wing) => wing.Id === form.wing) || null}
                      onChange={(event, newValue) => {
                        setForm((prev) => ({
                          ...prev,
                          wing: newValue ? newValue.Id : '',
                        }));
                      }}
                      label={
                        <span>
                          Wing <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      disabled={isFormDisabled || formMode === Form_Mode.edit}
                      onAddClick={openWingTab}
                      onRefreshClick={handleRefreshWings}
                      isRefreshing={isRefreshingWing}
                    /> */}
                  </Grid>
                </Grid>
              </Box>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} className="form_field">
                <FormControl
                  variant="filled"
                  fullWidth
                  className="custom-select"
                >
                  <InputLabel id="floor-select-label">
                    Floor<span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <Select
                    labelId="floor-select-label"
                    id="floor-select"
                    name="floor"
                    value={form.floor}
                    disabled={isFormDisabled || formMode === Form_Mode.edit}
                    onChange={handleInputChange}
                    className="custom-textfield"
                    sx={{
                      borderRadius: 1,
                      paddingRight: '30px',
                    }}
                    endAdornment={
                      (!isFormDisabled || formMode === Form_Mode.edit || formMode === Form_Mode.add) && (
                        <InputAdornment position="end">
                          <AddIcon
                            onClick={openFloorTab} 
                            style={{ cursor: "pointer", fontSize: '18px', color: '#2196f3' }}
                          />
                          <RefreshIcon
                            onClick={handleRefreshFloors} 
                            sx={{

                              transition: 'transform 0.3s ease',
                              cursor: 'pointer',
                              fontSize: '18px',
                              color: '#4caf50',
                            }}
                            style={spinAnimation}
                          />
                          <style>
                            {`
                            @keyframes spin {
                              from {
                                transform: rotate(0deg);
                              }
                              to {
                                transform: rotate(360deg);
                              }
                            }
                          `}
                          </style>
                        </InputAdornment>
                      )
                    }
                  >
                    {floors.map((floor) => {
                      return (
                        <MenuItem key={floor.Id} value={floor.Id}>
                          {floor.Name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
                {/* <CustomAutoCompleteNew
                  options={floors}
                  value={floors.find((floor) => floor.Id === form.floor) || null}
                  onChange={(event, newValue) => {
                    setForm((prev) => ({
                      ...prev,
                      floor: newValue ? newValue.Id : '',
                    }));
                  }}
                  label={
                    <span>
                      Floor <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  disabled={isFormDisabled || formMode === Form_Mode.edit}
                  onAddClick={openFloorTab}
                  onRefreshClick={handleRefreshFloors}
                  isRefreshing={isRefreshingFloor} // Ensure you have this state defined
                />*/}
              </Grid> 
              <Grid item xs={12} md={6} className="form_field">
                <FormControl
                  variant="filled"
                  fullWidth
                  className="custom-select"
                >
                  <InputLabel id="roomType-select-label">
                    Room Type<span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <Select
                    labelId="roomType-select-label"
                    id="roomType-select"
                    name="roomType"
                    value={form.roomType}
                    disabled={isFormDisabled || formMode === Form_Mode.edit}
                    onChange={handleInputChange}
                    className="custom-textfield"
                    sx={{
                      borderRadius: 1,
                      paddingRight: '30px',
                    }}
                    endAdornment={
                      (!isFormDisabled || formMode === Form_Mode.edit || formMode === Form_Mode.add) && (
                        <InputAdornment position="end">
                          <AddIcon
                            onClick={openRoomTypeTab} 
                            style={{ cursor: "pointer", fontSize: '18px', color: '#2196f3' }}
                          />
                          <RefreshIcon
                            onClick={handleRefreshRoomTyp} 
                            sx={{

                              transition: 'transform 0.3s ease',
                              cursor: 'pointer',
                              fontSize: '18px',
                              color: '#4caf50',
                            }}
                            style={spinAnimation3}
                          />
                          <style>
                            {`
                            @keyframes spin {
                              from {
                                transform: rotate(0deg);
                              }
                              to {
                                transform: rotate(360deg);
                              }
                            }
                          `}
                          </style>
                        </InputAdornment>
                      )
                    }
                  >
                    {roomType.map((roomtype) => {
                      return (
                        <MenuItem key={roomtype.Id} value={roomtype.Id}>
                          {roomtype.Name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
                {/* <CustomAutoCompleteNew
                  options={roomType} // Assuming roomType is an array of objects with Id and Name
                  value={roomType.find((type) => type.Id === form.roomType) || null}
                  onChange={(event, newValue) => {
                    setForm((prev) => ({
                      ...prev,
                      roomType: newValue ? newValue.Id : '',
                    }));
                  }}
                  label={
                    <span>
                      Room Type <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  disabled={isFormDisabled || formMode === Form_Mode.edit}
                  onAddClick={openRoomTypeTab}
                  onRefreshClick={handleRefreshRoomTyp}
                  isRefreshing={isRefRoomType} // Ensure you have this state defined
                /> */}
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label={
                    <span>
                      Room No.<span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  name="roomNo"
                  value={form.roomNo}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  variant="filled"
                  className="custom-textfield"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label={<span>Sqft</span>}
                  name="sqft"
                  value={form.sqft}
                  onChange={handleInputChange}
                  variant="filled"
                  disabled={isFormDisabled}
                  className="custom-textfield"
                />
              </Grid>
            </Grid>
          </Box>
        </Grid>
        <Grid
          item
          lg={4}
          md={4}
          xs={12}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            gap={2}
            border="1px solid #ccc"
            borderRadius={1}
            width={130}
            height={150}
            overflow="hidden"
            position="relative"
          >
            {selectedImage ? (
              <img
                src={selectedImage}
                alt="Uploaded Preview"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            ) : (
              <Typography
                variant="body2"
                color="textSecondary"
                style={{ textAlign: "center" }}
              >
                Image Preview
              </Typography>
            )}
          </Box>
          <input
            accept="image/*"
            style={{ display: "none" }}
            id="upload-photo"
            type="file"
            onChange={handleImageChange}
          />
          <label htmlFor="upload-photo">
            <Button
              // variant="contained"
              component="span"
              style={{ marginTop: "5px" }}
            >
              Upload Image
            </Button>
          </label>
        </Grid>
        <Grid item lg={12} md={12} xs={12}>
          <Box display="flex" flexDirection="column" gap={2}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label={<span>Total Beds</span>}
                  name="totalBeds"
                  value={form.totalBeds}
                  onChange={handleInputChange}
                  variant="filled"
                  disabled={isFormDisabled}
                  className="custom-textfield"
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label={<span>Monthly Rent</span>}
                  name="monthlyRent"
                  value={form.monthlyRent}
                  onChange={handleInputChange}
                  variant="filled"
                  disabled={isFormDisabled}
                  className="custom-textfield"
                />
              </Grid>
            </Grid>
            <Grid item xs={12} md={12} lg={8}>
              <Grid container spacing={2}>
                {/* <Grid item md={3} xs={12}>
                 <RoomMasterFormOneButton 
                  
                  PropId={form.property}  formMode={formMode}  isEditable={mode === Form_Mode.add || mode === Form_Mode.edit} />
                </Grid> */}
                {/* <Grid item md={3} xs={12}>
                <RoomMasterFormOneButtonTwo 
                PropId={form.property} formMode={formMode}  isEditable={mode === Form_Mode.add || mode === Form_Mode.edit} />
                </Grid> */}
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
}
